import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { selectAppState } from './app.selector';
import { pagesAdapter } from '../adapters/page.adapter';

const selectPageStore = createSelector(
    selectAppState,
    (state: AppState) => state.pages
)

export const {
  selectIds: selectPageIds,
  selectEntities: selectPageEntities,
  selectAll: selectAllPages,
  selectTotal: selectTotalPages,
} = pagesAdapter.getSelectors(createSelector(selectPageStore, state => state));

export const selectTerms = createSelector(
    selectAllPages,
    state => state.find(x => x.title === 'Terms & Conditions')
)

export const selectPrivacyPolicy = createSelector(
    selectAllPages,
    state => state.find(x => x.title === 'Privacy Policy')
)